import React from 'react'
import TextField from '@material-ui/core/TextField';
import MenuItem from '@material-ui/core/MenuItem';
import ReactTooltip from 'react-tooltip'

const DropDown = props => (
    <div className="form-input-container">
        <b>{props.title}</b>
        <TextField
            select
            style={{width: '230px', paddingLeft: '20px'}}
            label=""
            name={props.name}
            data-tip data-for={props.name}
            value={props.value}
            onChange={props.handleInputChange}>

            {props.dropdownOptions.map(option => (
                <MenuItem key={option.value} value={option.value}>
                    {option.label}
                </MenuItem>
            ))}
        </TextField>

        <ReactTooltip id={props.name} place="right" type="light" effect="solid">
            {props.tooltip}
        </ReactTooltip>
    </div>

)
export default DropDown;
